import { Component, Input, OnInit } from '@angular/core';
import { EventosService } from 'src/app/services/eventos.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-evento-box',
  templateUrl: './evento-box.component.html',
  styleUrls: ['./evento-box.component.css'],
})
export class EventoBoxComponent implements OnInit {
  @Input() evento;
  @Input() userUid;
  fechaActual;
  borrarAlerta: boolean = false;
  asistira = false;
  noasistira = false;
  verParticipantes: boolean = false;
  eventoDatos: any = {};
  creador: any = '';
  asistentes = [];
  noasistentes = [];
  emails = new Array()
  fechaFinal:any;
  participantesTotales:number = 0;
  estudiantes: any=new Array();
  borrarA : boolean = false;
  borrarE : boolean = false;
  eventId: string = '';
  deletingEvent = false;
  eventDeleted = false;


  constructor(
    private eventosService: EventosService,
    private userService: UserService,
    private NotificacionesService: NotificacionesService
  ) {}

  ngOnInit(): void {
    this.getFecha();


    this.asistira = false;
    this.noasistira = false;
    this.eventoDatos = this.evento.payload.doc.data();
    this.eventId = this.getEventId();
    if(this.evento.payload.doc.data().emails){   this.emails = this.evento.payload.doc.data().emails}
    if(this.evento.payload.doc.data().estudiantes){ this.estudiantes = this.evento.payload.doc.data().estudiantes}
   
    if(this.estudiantes){this.participantesTotales+=this.estudiantes.length}
    if(this.emails){this.participantesTotales+=this.emails.length}
    
    this.fechaFinal = this.toDate(this.eventoDatos['end_date'] || this.eventoDatos['fecha_final']);

    const asistentesIds = this.eventoDatos.assisting_members || this.eventoDatos.asistentes || [];
    const noAsistentesIds = this.eventoDatos.non_assisting_members || this.eventoDatos.noasistentes || [];
    this.asistira = asistentesIds.includes(this.userUid);
    this.noasistira = noAsistentesIds.includes(this.userUid);

    asistentesIds.forEach((element) => {
      this.userService.getUserById(element).subscribe((item) => {
        if (item.length > 0) {
          var it = item[0].payload.doc.data();
          this.asistentes.push(it);
        }
      });
    });
    //Comprueba si el usuario esta en el listado de gente que asistirá
    //Comprueba si el usuario esta en el listado de gente que no asistirá
    noAsistentesIds.forEach((element) => {
      this.userService.getUserById(element).subscribe((item) => {
        if (item.length > 0) {
          var it = item[0].payload.doc.data();
          this.noasistentes.push(it);
        }
      });
    });
    this.userService
      .getUserById(this.getCreatorId())
      .subscribe((item) => {
        if (!item[0]) {
          return;
        }
        this.creador = item[0].payload.doc.data();
      });
  }

  toDate(value: any): Date | null {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return value;
    }

    if (typeof value.toDate === 'function') {
      return value.toDate();
    }

    if (typeof value === 'object') {
      const seconds = value.seconds || value._seconds;
      if (typeof seconds === 'number') {
        return new Date(seconds * 1000);
      }
    }

    const parsedDate = new Date(value);
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
  }

  getEventStartDate(): Date | null {
    return this.toDate(this.eventoDatos['start_date'] || this.eventoDatos['fecha_inicio']);
  }
  
  getFecha() {
    const current = new Date();
    current.setHours(current.getHours());
    current.setMinutes(current.getMinutes());
    current.setMonth(current.getMonth());
    current.setDate(current.getDate());
    this.fechaActual = current;
    return current;
  }

  //Elimina el evento dependiendo de si es el creador
  async deleteevent(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();

    if (this.deletingEvent) {
      return;
    }

    var creado = this.getCreatorId();
    if (creado == this.userUid) {
      const eventId = this.getEventId() || await this.findEventIdFromList();
      const deleteRequest = eventId
        ? this.eventosService.DeleteEvento(eventId)
        : this.eventosService.DeleteMatchingEvento(this.getEventDeletePayload());

      if (eventId) {
        this.eventId = eventId;
      }
      this.deletingEvent = true;
      deleteRequest
        .then((result: any) => {
          this.borrarE = false;
          this.eventDeleted = true;
          this.deleteEventNotifications(eventId || result?.id);
        })
        .catch((error) => {
          if (error?.status === 400 && error?.error?.error?.includes('does not exist')) {
            this.borrarE = false;
            this.eventDeleted = true;
            return;
          }

          console.error('No se pudo eliminar el evento', error);
        })
        .finally(() => {
          this.deletingEvent = false;
        });
    } else {
      this.borrarAlerta = true;
      setTimeout(() => {
        this.borrarAlerta = false;
      }, 2000);
    }
  }

  //Añade al usuario al listado de gente que asistirá
  getCreatorId() {
    const data = this.eventoDatos || this.evento?.payload?.doc?.data?.() || {};
    return data['admin'] || data['created_by'] || data['creado'] || '';
  }

  private getEventId() {
    const data = this.eventoDatos || this.evento?.payload?.doc?.data?.() || {};
    const docId = this.evento?.payload?.doc?.id;
    return data['id'] || data['_id'] || data['uid'] || data['doc_id'] || data['docId'] || data['documentId'] || data['document_id'] || data['eventId'] || data['event_id'] || data['idEvento'] || data['eventoId'] || data['idevento'] || docId || '';
  }

  private async findEventIdFromList(): Promise<string> {
    const eventos = await this.eventosService.getEventosByUseridOrdenado(this.userUid).toPromise();
    const matchingEvent = (eventos || []).find((evento) =>
      this.isSameEvent(evento?.payload?.doc?.data?.() || evento)
    );

    return matchingEvent?.payload?.doc?.id || '';
  }

  private isSameEvent(eventData: any) {
    const current = this.eventoDatos || {};
    return this.normalizeText(eventData?.name || eventData?.nombre) === this.normalizeText(current?.name || current?.nombre)
      && this.normalizeText(eventData?.description || eventData?.descripcion) === this.normalizeText(current?.description || current?.descripcion)
      && this.sameDate(eventData?.start_date || eventData?.fecha_inicio, current?.start_date || current?.fecha_inicio)
      && this.sameDate(eventData?.end_date || eventData?.fecha_final, current?.end_date || current?.fecha_final);
  }

  private normalizeText(value: any) {
    return (value || '').toString().trim().toLowerCase();
  }

  private sameDate(left: any, right: any) {
    const leftDate = this.toDate(left);
    const rightDate = this.toDate(right);

    if (!leftDate || !rightDate) {
      return !leftDate && !rightDate;
    }

    return leftDate.getTime() === rightDate.getTime();
  }

  private deleteEventNotifications(eventId: string) {
    if (!eventId) {
      return;
    }

    this.NotificacionesService.searchNotification(eventId).subscribe((noti) => {
      noti.forEach((lanoti) => {
        const notificationId = lanoti.payload.doc.id;
        if (notificationId) {
          this.NotificacionesService.removeNotificacion(notificationId).catch(() => null);
        }
      });
    });
  }

  private getEventDeletePayload() {
    const data = this.eventoDatos || {};

    return {
      admin: this.getCreatorId(),
      name: data['name'] || data['nombre'],
      description: data['description'] || data['descripcion'] || null,
      start_date: data['start_date'] || data['fecha_inicio'],
      end_date: data['end_date'] || data['fecha_final'],
    };
  }

  isOwnEvent() {
    return this.getCreatorId() == this.userUid;
  }

  addAsistir() {
    this.confirmAttendance(true);
  }
  //Añade al usuario al listado de gente que no asistirá
  addNoAsistir() {
    this.confirmAttendance(false);
  }

  confirmAttendance(willAttend: boolean) {
    if (!this.eventId) {
      return;
    }
    this.setAttendanceState(willAttend);
    const addRequest = willAttend
      ? this.eventosService.addAssistingMember(this.eventId, this.userUid)
      : this.eventosService.addNonAssistingMember(this.eventId, this.userUid);
    const removeRequest = willAttend
      ? () => this.eventosService.removeNonAssistingMember(this.eventId, this.userUid).catch(() => null)
      : () => this.eventosService.removeAssistingMember(this.eventId, this.userUid).catch(() => null);

    addRequest
      .then(removeRequest)
      .catch(() => this.saveAttendanceWithEventPatch(willAttend));
  }

  private saveAttendanceWithEventPatch(willAttend: boolean) {
    var event = this.evento.payload.doc.data();
    const asistentes = event['asistentes'] || event['assisting_members'] || [];
    const noasistentes = event['noasistentes'] || event['non_assisting_members'] || [];

    event['asistentes'] = willAttend
      ? this.addUnique(asistentes, this.userUid)
      : asistentes.filter((uid) => uid != this.userUid);
    event['noasistentes'] = willAttend
      ? noasistentes.filter((uid) => uid != this.userUid)
      : this.addUnique(noasistentes, this.userUid);
    event['assisting_members'] = event['asistentes'];
    event['non_assisting_members'] = event['noasistentes'];

    this.eventosService
      .editEvento(this.eventId, event)
      .then(() => this.setAttendanceState(willAttend));
  }

  private setAttendanceState(willAttend: boolean) {
    this.asistira = willAttend;
    this.noasistira = !willAttend;
    this.eventoDatos['asistentes'] = willAttend
      ? this.addUnique(this.eventoDatos['asistentes'] || this.eventoDatos['assisting_members'] || [], this.userUid)
      : (this.eventoDatos['asistentes'] || this.eventoDatos['assisting_members'] || []).filter((uid) => uid != this.userUid);
    this.eventoDatos['noasistentes'] = willAttend
      ? (this.eventoDatos['noasistentes'] || this.eventoDatos['non_assisting_members'] || []).filter((uid) => uid != this.userUid)
      : this.addUnique(this.eventoDatos['noasistentes'] || this.eventoDatos['non_assisting_members'] || [], this.userUid);
    this.eventoDatos['assisting_members'] = this.eventoDatos['asistentes'];
    this.eventoDatos['non_assisting_members'] = this.eventoDatos['noasistentes'];
  }

  private addUnique(items: any[], value: any) {
    return items.includes(value) ? items : items.concat([value]);
  }
  ver() {
    this.verParticipantes == false
      ? (this.verParticipantes = true)
      : (this.verParticipantes = false);
  }

  deleteAsistencia() {
    if (!this.eventId) {
      return;
    }
   var participantes = this.evento.payload.doc.data()['estudiantes'] || [];
    var asistentes = this.evento.payload.doc.data()['asistentes'] || this.evento.payload.doc.data()['assisting_members'] || [];
    var noasistentes = this.evento.payload.doc.data()['noasistentes'] || this.evento.payload.doc.data()['non_assisting_members'] || [];
    if(this.asistira){
      this.eventoDatos['asistentes'] = asistentes.filter((m) => m != this.userUid);
    }
    if(this.noasistira){
      this.eventoDatos['noasistentes'] = noasistentes.filter((m) => m != this.userUid);
    }
    if (participantes.length != 0) {
      var asis = participantes.indexOf(this.userUid);
      if (asis != -1) {
        participantes.splice(asis, 1);
        this.eventoDatos['estudiantes'] = participantes;


        this.eventosService.editEvento(
          this.eventId,
          this.eventoDatos
        );
      }
    }
  }
  borrarPop(event?: Event){
    event?.preventDefault();
    event?.stopPropagation();
    this.borrarA? this.borrarA = false : this.borrarA = true;
  }
  borrarPopE(event?: Event){
    event?.preventDefault();
    event?.stopPropagation();
    this.borrarE? this.borrarE = false : this.borrarE = true;
  }

  openDeleteEventConfirm(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    this.borrarA = false;
    this.borrarE = true;
  }
}
